export const string = {
  //dashboard: 'With all of the styling tool options available in today’s market'
  nodata: "No Data Found",
};
